import { shouldRender as shouldRenderStreamPlus } from '../components/organisms/StreamPlus/utils'
import {
  shouldRenderMobilityPhone,
  shouldRenderMobilityWirelessHomePhone,
  shouldRenderOrbitMobilityPhone
} from '../components/organisms/MobilityPhone/utils'
import { shouldRender as shouldRenderByod } from '../components/organisms/Byod/utils'
import {
  shouldRenderConnectedDevices,
  shouldRenderOrbitTablet,
  shouldRenderMobilityInternet
} from '../components/organisms/MobilityConnectedDevice/utils'
import { shouldRender as shouldRenderGifts } from '../components/organisms/Gift/utils'
import { shouldRender as shouldRenderInternet } from '../components/organisms/Internet/utils'
import { shouldRender as shouldRenderOptikTV } from '../components/organisms/OptikTV/utils'
import { shouldRender as shouldRenderPikTV } from '../components/organisms/PikTV/utils'
import { shouldRender as shouldRenderSmartHomeSecurity } from '../components/organisms/Security/SmartHomeSecurity/utils'
import { shouldRender as shouldRenderAddon } from '../components/organisms/Addon/utils'
import { shouldRender as shouldRenderHomePhone } from '../components/organisms/HomePhone/utils'
import { shouldRender as shouldRenderBusinessConnect } from '../components/organisms/BusinessConnect/utils'
import { shouldRender as shouldRenderSecureBusiness } from '../components/organisms/Security/SecureBusiness/utils'
import { shouldRender as shouldRenderLivingWellCompanion } from '../components/organisms/LivingWellCompanion/utils'
import { shouldRender as shouldRenderMobilityAccessory } from '../components/organisms/MobilityAccessory/utils'

export const getNumberOfCartModuleRendered = (cart, featureFlags) => {
  const modules = [
    shouldRenderMobilityPhone,
    shouldRenderMobilityWirelessHomePhone,
    shouldRenderOrbitMobilityPhone,
    shouldRenderConnectedDevices,
    shouldRenderStreamPlus,
    shouldRenderByod,
    shouldRenderOrbitTablet,
    shouldRenderMobilityInternet,
    shouldRenderGifts,
    shouldRenderInternet,
    shouldRenderOptikTV,
    shouldRenderPikTV,
    shouldRenderSmartHomeSecurity,
    shouldRenderAddon,
    shouldRenderHomePhone,
    shouldRenderBusinessConnect,
    shouldRenderSecureBusiness,
    shouldRenderLivingWellCompanion,
    shouldRenderMobilityAccessory
  ]
  return modules.map((m) => m(cart, featureFlags)).filter((r) => r === true).length
}
